import React from 'react';
import PropTypes from 'prop-types';

export default function CheckoutButton(props) {
    const stateCss = props.isDisabled ? 'is-disabled' : '';

    return (
        <button
            className={`button button--super ticket-builder__button ${stateCss}`}
            onClick={() => props.onStartCheckout(props.mc)}
            ref={props.checkoutBtnRef}
            disabled={props.isDisabled}
            id="basketPay"
        >
            <span className="button-content button-content--icon">
                <span>Pay{props.mc ? ' with Mastercard' : ''}</span>
                <svg className="icon button__arrow-left" width="14" height="12" focusable="false">
                    <use xlinkHref="#icon-arrow-right"></use>
                </svg>
            </span>
        </button>
    );
}

CheckoutButton.defaultProps = {
    mc: false,
};

CheckoutButton.propTypes = {
    mc: PropTypes.bool,
    checkoutBtnRef: PropTypes.func,
    isDisabled: PropTypes.bool,
    onStartCheckout: PropTypes.func.isRequired
};
